<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Minimum Threshold Type</pdq-heading>
        <span class="card__subtitle">When to show this upsell</span>
      </div>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <pdq-radio-group [formControl]="formGroup.controls.minimumThresholdType" alignment="vertical">
        <pdq-radio-button value="cart_value" text="Cart Value"></pdq-radio-button>
        <pdq-radio-button value="item_count" text="Item Count"></pdq-radio-button>
      </pdq-radio-group>
    </div>
  </div>
</pdq-card>

<smart-cart-goals-custom-code-card
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"></smart-cart-goals-custom-code-card>
